import loggerMiddleware from '../features/middleware/logger.middleware'

// eslint-disable-next-line
export default [
  loggerMiddleware,
  // add your middlewares here
]
